import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-page',
    template: '',
    standalone: false
})
export class DashboardPageComponent {
  // * Empty template - this component does nothing but we need it
}
